import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link as RouterLink, useParams } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        backgroundColor: theme.palette.primary.main,
    },
    text: {
        color: theme.palette.grey[50],
    },
    textField: {
        backgroundColor: '#FFFFFF',
    },
    button: {
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: 16,
        height: 55,
        '&:hover': {
            color: theme.palette.grey[50],
        }
    },
    headerLogo: {
        maxWidth: '140px',
        padding: '12px',
        position: 'absolute',
        top: 0,
        left: 0
    }
}));

export default function ForgotPasswordResetSent() {
    const { email } = useParams();
    const classes = useStyles();

    return (
        <>
            <img className={classes.headerLogo} alt="GiftYa Logo" src="https://d2kn7nb9ubajli.cloudfront.net/logos/2020/GY_Logo_stack-white-trimmed.png" />
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh', paddingTop: '100px', paddingBottom: '20px' }}
                className={classes.root}
            >
                <Grid item xs={10}>
                    <Grid container justifyContent="center" className={classes.root} spacing={2}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                align="center"
                                className={classes.text}
                                paragraph
                            >
                                Password reset email sent!
                            </Typography>
                            <Typography
                                variant="body1"
                                align="center"
                                className={classes.text}
                                paragraph
                            >
                                We’ve sent an email to
                                { ' ' }
                                {email}
                                { ' ' }
                                with a link to reset your password.
                            </Typography>
                            <Typography
                                variant="body1"
                                align="center"
                                className={classes.text}
                                paragraph
                            >
                                If you don’t receive an email in a few minutes, please check your spam folder, email us at support@giftya.com or call 855-534-5222.
                            </Typography>
                        </Grid>
                        <Grid item xs={10} sm={5} lg={3}>
                            <Button
                                fullWidth
                                component={RouterLink}
                                variant="contained"
                                to="/"
                                color="secondary"
                                type="button"
                                className={classes.button}
                            >
                                Return to log in
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
